"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.markerPropsToFeatureCollection = exports.childrenToFeatureCollection = void 0;
const helpers_1 = require("@turf/helpers");
const turf_1 = require("@turf/turf");
const React = __importStar(require("react"));
const react_children_utilities_1 = require("react-children-utilities");
require("./FabricMapMarker.scss");
/**
 * Convert react children to a feature collection of polygons.
 * That feature collection is passed to the map layer for clustering.
 */
const childrenToFeatureCollection = (children) => {
    /**
     * Deep map iterates over every child and all of their descendants.
     */
    const mapMarkers = (0, react_children_utilities_1.deepMap)(children, (child) => {
        /**
         * We'll ignore everything else someone might have passed in.
         */
        if ((0, react_children_utilities_1.getElementName)(child) === "FabricMapMarker") {
            return child;
        }
        else {
            return undefined;
        }
    }).filter((element) => !!element);
    const features = [];
    React.Children.forEach(mapMarkers, (marker) => {
        const { coordinates } = marker.props;
        const polygon = (0, turf_1.circle)(coordinates, 0.01);
        features.push(polygon);
    });
    return (0, helpers_1.featureCollection)(features);
};
exports.childrenToFeatureCollection = childrenToFeatureCollection;
/**
 * Convert an array of markers to a feature collection of polygons.
 * That feature collection is passed to the map layer for clustering.
 */
const markerPropsToFeatureCollection = (markers) => {
    const features = markers.map(({ coordinates }) => {
        return (0, turf_1.circle)(coordinates, 0.01);
    });
    return (0, helpers_1.featureCollection)(features);
};
exports.markerPropsToFeatureCollection = markerPropsToFeatureCollection;
